import { attachShareScopeMap } from "./attachShareScopeMap.js";
import federation, { bundlerRuntime, bundlerRuntimeOptions, initOptions, instance, runtime } from "./index.js";

export { attachShareScopeMap, bundlerRuntime, bundlerRuntimeOptions, federation as default, initOptions, instance, runtime };